import ProgressBar from 'react-bootstrap/ProgressBar';

export default function ExecutingProgress({ now }) {

    return <div className='progress-holder'>
        <h4>Executing</h4>
        <ProgressBar max={1} now={now} />
        </div>
}